// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8afa5342","453":"2949d301","455":"99ee2d06"}[chunkId] + ".chunk.js";
};